import React, { Component } from "react";

import { imgSrcAddPrefix } from "../../utility/global";

export default class ProductionListModal extends Component {
    render() {
        const {
            updateShowProductionListModal,
            isShowProductionListModal,
            listData,
        } = this.props;
        return (
            <div
                className={
                    isShowProductionListModal
                        ? "modal fade show d-flex"
                        : "modal fade show"
                }
                id="ProductionListModal"
                tabIndex="-1"
                aria-labelledby="loginErrorModalLiveLabel"
                aria-modal="true"
                role="dialog"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // updateShowProductionListModal(false)
                }}>
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5
                                className="modal-title"
                                id="loginErrorModalLabel">
                                產品組合清單
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={(e) =>
                                    updateShowProductionListModal(false)
                                }></button>
                        </div>
                        <div className="modal-body">
                            <ul className="list-group mb-3">
                                {!listData
                                    ? null
                                    : listData.map((item, index) => {
                                          if (item.sku !== "0") {
                                              return (
                                                  <li
                                                      key={index}
                                                      className="list-group-item d-flex justify-content-start">
                                                      <div className="listImg">
                                                          <img
                                                              className="img-fluid"
                                                              src={imgSrcAddPrefix(
                                                                  item.image
                                                              )}
                                                              alt="img"
                                                          />
                                                      </div>
                                                      <div className="my-auto">
                                                          <h6 className="my-0">
                                                              {item.name}
                                                              <span>
                                                                  {" "}
                                                                  x {item.qty}
                                                              </span>
                                                          </h6>
                                                          <small>
                                                              {item.sku}
                                                          </small>
                                                      </div>
                                                  </li>
                                              );
                                          }
                                          return <></>;
                                      })}
                            </ul>
                        </div>
                        <div className="modal-footer d-none">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal">
                                Close
                            </button>
                            <button type="button" className="btn btn-primary">
                                Save changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
